import { loadFont } from '@hts/shared/utils';
import { useEffect, useState } from 'react';

interface IUseDynamicFontProps {
  fontUrl?: string;
  fontFamily?: string;
}

export const useDynamicFont = ({
  fontFamily = '',
  fontUrl,
}: IUseDynamicFontProps): string | null => {
  const [loadedFontName, setLoadedFontName] = useState<string | null>(null);

  useEffect(() => {
    if (!fontUrl) return;

    const loadFontAsync = async () => {
      const fontName = await loadFont(fontUrl, fontFamily);

      setLoadedFontName(fontName);
    };

    loadFontAsync();
  }, [fontUrl, fontFamily]);

  return loadedFontName;
};
